export interface Heading {
    id: string;
    text: string;
    level: number;
}

export const processContent = (content: string): { processedContent: string; headings: Heading[] } => {
    const headings: Heading[] = [];
    let processedContent = content;

    // Regex to match h2 and h3 tags
    const headingRegex = /<(h[23])>(.*?)<\/\1>/g;

    processedContent = content.replace(headingRegex, (match, tag, text) => {
        // Generate a simple ID from the text
        const id = text
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '') // Remove accents
            .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric with hyphens
            .replace(/(^-|-$)/g, ''); // Remove leading/trailing hyphens

        const level = parseInt(tag.charAt(1));
        headings.push({ id, text, level });

        return `<${tag} id="${id}">${text}</${tag}>`;
    });

    return { processedContent, headings };
};
